import axios from 'axios'
import Storage from '../storage'


const getAxios = () => axios.create({
  baseURL: `${process.env.API_HOST}/${process.env.API_STAGE || ''}`,
  headers: { 'eq-api-jwt': Storage.get('auth_jwt') },
})

if (process.env.API_STAGE === '') {
  window.getAxios = getAxios
}

export default getAxios
